module.exports = __webpack_public_path__ + "img/build.afff0ba4.svg";